import { useEffect } from 'react';

import { Store } from '@flipdish/api-client-typescript';
import { useParams } from 'react-router-dom';

import { setSelected, storeActions } from '../actions/store.actions';
import { useAppDispatch } from './useAppDispatch';
import useQueryStoreIdAssociations from './useQueryStoreIdAssociations';

const useLoadStoreFromSalesChannelIdIntoRedux = ({
  store,
  linkedSalesChannelId,
  enabled = true,
  externalStoreId,
}: {
  store?: Store;
  linkedSalesChannelId?: string;
  enabled?: boolean;
  externalStoreId?: string;
}) => {
  const dispatch = useAppDispatch();
  // get the sales channel id or storeId (storeId for backwards compatability)
  const { channelId: channelIdFromUrl, storeId: oldStoreId } = useParams<{
    channelId: string;
    storeId: string;
  }>();

  const channelId = linkedSalesChannelId ?? channelIdFromUrl;

  // if sales channel id fetch the store based on sales channel id association
  const { storeId: salesChannelStoreId, loadingStoreAssociation } = useQueryStoreIdAssociations({
    salesChannelId: channelId,
    enabled: !!channelId && enabled,
  });

  const storeId = (oldStoreId || salesChannelStoreId || externalStoreId) ?? '';

  useEffect(() => {
    const storeIdNumber = storeId && Number(storeId);
    if (
      !loadingStoreAssociation &&
      (!store?.StoreId || store?.StoreId !== storeIdNumber) &&
      storeIdNumber
    ) {
      // set the selected store and load into redux
      dispatch(setSelected({ storeId: storeIdNumber }));
      dispatch(storeActions.load(storeIdNumber));
    }
    // For marketplace channels that don't have store associations, we don't need to load anything
    // but we still need to complete the loading process
  }, [storeId, loadingStoreAssociation, store?.StoreId]);

  return {
    loadingStoreAssociation,
    storeId,
  };
};

export default useLoadStoreFromSalesChannelIdIntoRedux;
